var t=function(t,a){var c=/\(.{1,4}\)/;return c.test(t)?t.replace(c,"(".concat(a,")")):t="(".concat(a,") ").concat(t)};export{t as updateCountInTitle};
//# sourceMappingURL=index.js.map
